import { render } from "./study_plan_public.vue?vue&type=template&id=362624ca"
import script from "./study_plan_public.vue?vue&type=script&lang=js"
export * from "./study_plan_public.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__